import { render, staticRenderFns } from "./CombinationTable.vue?vue&type=template&id=74f461c8&scoped=true&"
import script from "./CombinationTable.vue?vue&type=script&lang=js&"
export * from "./CombinationTable.vue?vue&type=script&lang=js&"
import style0 from "./CombinationTable.vue?vue&type=style&index=0&id=74f461c8&scoped=true&lang=scss&"
import style1 from "./CombinationTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f461c8",
  null
  
)

export default component.exports